import { useState } from "react";
import { Link, useRouterState } from "@tanstack/react-router";
import logoUrl from "@/assets/clutchcube-logo.png";
import { trackEvent } from "@/lib/analytics";

const links = [
  { hash: "why-now", label: "Why Now" },
  { hash: "the-moment", label: "The Moment" },
  { hash: "what-is", label: "What It Is" },
  { hash: "moments", label: "Moments" },
  { hash: "technology", label: "Technology" },
  { hash: "franchise", label: "Franchise" },
];

export function Nav() {
  const [open, setOpen] = useState(false);
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const onHome = pathname === "/";

  const sectionHref = (hash: string) => (onHome ? `#${hash}` : `/#${hash}`);
  const investHref = onHome ? "#invest" : "/#invest";

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-background/60 border-b border-border/60">
      <div className="mx-auto max-w-7xl px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center" aria-label="ClutchCube home" onClick={() => setOpen(false)}>
          <img src={logoUrl} alt="ClutchCube" className="h-8 w-auto" />
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm uppercase tracking-wider text-muted-foreground">
          {links.map((l) => (
            <a key={l.hash} href={sectionHref(l.hash)} className="hover:text-foreground transition">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href={investHref}
            onClick={() => trackEvent("investor_cta_click", { placement: "nav" })}
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2 text-xs uppercase tracking-widest font-semibold bg-primary text-primary-foreground rounded-sm hover:opacity-90 transition shadow-glow"
          >
            Investor Deck
          </a>
          <button
            type="button"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="md:hidden inline-flex items-center justify-center w-10 h-10 border border-border/60 rounded-sm text-foreground"
          >
            <span className="sr-only">Menu</span>
            <div className="flex flex-col gap-1.5">
              <span className={`block h-px w-5 bg-foreground transition-transform ${open ? "translate-y-[6px] rotate-45" : ""}`} />
              <span className={`block h-px w-5 bg-foreground transition-opacity ${open ? "opacity-0" : ""}`} />
              <span className={`block h-px w-5 bg-foreground transition-transform ${open ? "-translate-y-[6px] -rotate-45" : ""}`} />
            </div>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-border/60 bg-background/95 backdrop-blur-md">
          <nav className="mx-auto max-w-7xl px-6 py-6 flex flex-col gap-4 text-sm uppercase tracking-wider text-muted-foreground">
            {links.map((l) => (
              <a
                key={l.hash}
                href={sectionHref(l.hash)}
                onClick={() => setOpen(false)}
                className="hover:text-foreground transition"
              >
                {l.label}
              </a>
            ))}
            <a
              href={investHref}
              onClick={() => {
                trackEvent("investor_cta_click", { placement: "nav_mobile" });
                setOpen(false);
              }}
              className="mt-2 inline-flex items-center justify-center px-4 py-3 text-xs uppercase tracking-widest font-semibold bg-primary text-primary-foreground rounded-sm shadow-glow"
            >
              Investor Deck
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
